/* Evenimente Ergoliv pentru Statsig.
 *
 * Rolul lor NU e sa produca grafice. La ~10 comenzi si ~20 de cosuri abandonate
 * pe luna, orice procent calculat pe atatea puncte are marja de eroare mai mare
 * decat diferenta pe care ai vrea s-o observi. Rolul lor e sa fie ETICHETE pe
 * inregistrarile de sesiune, ca sa poti filtra „arata-mi cine a ales pachetul
 * mare si n-a cumparat" si sa te uiti la acele cateva inregistrari.
 *
 * add_to_cart si begin_checkout SE dubleaza fata de GA4, din 18 sep 2026. Pana
 * atunci nu se justifica. S-a schimbat cand a pornit testul A/B pe header:
 * GA4 nu stie in ce brat e vizitatorul, deci un experiment fara aceste doua
 * evenimente in Statsig n-are nicio metrica de avarie. Statsig le leaga singur
 * de expuneri, deci nu trebuie etichetate cu varianta.
 *
 * Regula de baza: nimic din fisierul asta nu are voie sa arunce o eroare care
 * sa opreasca pagina. Totul e in try/catch, iar daca Statsig lipseste, tacem.
 */
(function () {
  'use strict';
  var CTX = window.ErgolivAnalytics || {};
  var q = [];           // evenimente inainte ca Statsig sa fie gata
  var client = null;

  /* Consimtamant. Shopify expune decizia utilizatorului prin customerPrivacy.
   * Nu logam nimic pana nu e „da" pe analytics. Daca API-ul lipseste cu totul,
   * ramanem tacuti — mai bine pierdem date decat sa colectam fara acord.
   * Nota: scriptul Statsig din header-group.json porneste independent de asta;
   * vezi docs/analytics/audit-analytics.md. */
  function analyticsPermis() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return false;
      return cp.analyticsProcessingAllowed() === true;
    } catch (e) { return false; }
  }

  // reevaluam cand omul apasa pe banner
  document.addEventListener('visitorConsentCollected', function () {
    try { if (analyticsPermis() && client) { while (q.length) client.logEvent(q.shift()); } } catch (e) {}
  });

  function ready(cb, tries) {
    tries = tries || 0;
    try {
      var S = window.__STATSIG__;
      if (S && typeof S.instance === 'function') {
        var i = S.instance();
        if (i && typeof i.logEvent === 'function') return cb(i);
      }
    } catch (e) { /* ignoram */ }
    if (tries < 40) setTimeout(function () { ready(cb, tries + 1); }, 250);
  }

  function log(name, value, meta) {
    var ev = { eventName: name, value: value == null ? '' : String(value), metadata: meta || {} };
    try {
      ev.metadata.page = location.pathname;
      if (CTX.template) ev.metadata.template = CTX.template;
    } catch (e) {}
    if (!analyticsPermis()) { if (q.length < 30) q.push(ev); return; }  // asteapta acordul
    if (client) { try { client.logEvent(ev); } catch (e) {} }
    else q.push(ev);
  }
  window.ergolivTrack = log;   // ca sa poata fi apelat si din alte scripturi

  ready(function (inst) {
    client = inst;
    // Cine e clientul. Fara asta, nicio inregistrare nu se leaga de o comanda.
    try {
      if (CTX.customerId && analyticsPermis()) {
        inst.updateUserAsync({
          userID: String(CTX.customerId),
          custom: { orders: CTX.customerOrders || 0, market: CTX.market || '' }
        });
      }
    } catch (e) {}
    if (analyticsPermis()) { while (q.length) { try { inst.logEvent(q.shift()); } catch (e) {} } }

    if (CTX.product) {
      log('pdp_view', CTX.product.handle, {
        titlu: CTX.product.title || '',
        pret: String(CTX.product.price || ''),
        in_stoc: String(CTX.product.available),
        tip: CTX.product.type || ''
      });
    }
  });

  // --- clicuri, prin delegare: rezista la schimbari de markup ---
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var el;

      if ((el = t.closest('[data-lnx-bundle]'))) {
        return log('bundle_selected', el.getAttribute('data-lnx-bundle'),
                   { produs: (CTX.product && CTX.product.handle) || '' });
      }
      if ((el = t.closest('[data-lnx-opt], .lnx-opt'))) {
        return log('variant_selected',
                   el.getAttribute('data-lnx-opt') || (el.textContent || '').trim().slice(0, 40),
                   { produs: (CTX.product && CTX.product.handle) || '' });
      }
      if ((el = t.closest('a[href*="wa.me"], a[href*="whatsapp"], [class*="whatsapp"]'))) {
        return log('whatsapp_click', (CTX.product && CTX.product.handle) || location.pathname);
      }
      if ((el = t.closest('a[href*="showroom"]'))) {
        return log('showroom_click', el.getAttribute('href') || '');
      }
      if ((el = t.closest('[name="checkout"], a[href="/checkout"]'))) {
        return log('begin_checkout', String(CTX.cartCount || ''));
      }
    } catch (err) { /* niciodata nu stricam pagina */ }
  }, true);

  // --- adaugarea in cos: singura metrica de avarie a testului A/B ---
  document.addEventListener(
    'submit',
    function (e) {
      try {
        var f = e.target;
        if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
        log('add_to_cart', (CTX.product && CTX.product.handle) || location.pathname, {
          pret: String((CTX.product && CTX.product.price) || '')
        });
      } catch (err) { /* niciodata nu stricam pagina */ }
    },
    true
  );

  // --- acordeoane: ce citesc oamenii inainte sa cumpere ---
  document.addEventListener('toggle', function (e) {
    try {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS' || !d.open) return;
      var s = d.querySelector('summary');
      var titlu = (s ? s.textContent : '').trim().replace(/\s+/g, ' ').slice(0, 60);
      if (titlu) log('spec_opened', titlu, { produs: (CTX.product && CTX.product.handle) || '' });
    } catch (err) {}
  }, true);
})();
